import React, { useState, useEffect } from 'react';
import Board from 'react-trello';
import { message } from 'antd/lib';
import GaragesAllocationCard from './components/GaragesAllocationCard';
import { momentArray } from '../../common/helpers';
import { saveFiltersInLocalStorage, getSavedFiltersFromLocalStorage } from '../../../common/helpers';
import FilterBar from '$app/shared/components/FilterBar';
import DateRangeFilter from '$app/shared/components/DateRangeFilter';
import SegmentFilter from '$app/shared/components/SegmentFilter';
import CndSelectFilter from '$app/shared/components/CndSelectFilter';
import GarageFilter from '$app/shared/components/GarageFilter';
import MasterStatusSelectFilter from '$app/shared/components/MasterStatusSelectFilter';
import { getColumnsWithBookings } from './logic/columnLogic';

const GaragesAllocation = ({ garages, bookings, earliestBookingDate }) => {
  const savedFilters = getSavedFiltersFromLocalStorage('garageAllocationFilters');

  // Filters selected by case managers
  const [filteredSegment, setFilteredSegment] = useState(savedFilters.segment);
  const [filteredDateRange, setFilteredDateRange] = useState(savedFilters.dateRange);
  const [filteredCndType, setFilteredCndType] = useState(savedFilters.cndType);
  const [filteredGarage, setFilteredGarage] = useState(savedFilters.garage);
  const [filteredStatus, setFilteredStatus] = useState(savedFilters.status);

  const clearAllFilters = () => {
    setFilteredSegment(null);
    setFilteredDateRange(null);
    setFilteredCndType(null);
    setFilteredGarage('');
    setFilteredStatus(null);
    localStorage.removeItem('garageAllocationFilters');
    message.success('Cleared all filters');
  };

  useEffect(
    () =>
      saveFiltersInLocalStorage('garageAllocationFilters', {
        segment: filteredSegment,
        dateRange: filteredDateRange,
        garage: filteredGarage,
        cndType: filteredCndType,
        status: filteredStatus,
      }),
    [filteredSegment, filteredDateRange, filteredGarage, filteredCndType, filteredStatus]
  );

  const userSelectedFilters = {
    filteredCndType,
    filteredDateRange,
    filteredGarage,
    filteredSegment,
    filteredStatus,
  };

  const columnsWithBookings = getColumnsWithBookings(
    bookings?.bookingToGarageAllocate || [],
    userSelectedFilters
  );

  return (
    <div className="allocation-page garage">
      <FilterBar
        mainFilters={
          <>
            <SegmentFilter onChange={setFilteredSegment} value={filteredSegment} />
            <DateRangeFilter
              onChange={setFilteredDateRange}
              value={momentArray(filteredDateRange)}
              earliestSelectableDate={earliestBookingDate}
            />
            <CndSelectFilter onChange={setFilteredCndType} value={filteredCndType} />
            <GarageFilter onSelect={setFilteredGarage} value={filteredGarage} garages={garages} />
            <MasterStatusSelectFilter onChange={setFilteredStatus} value={filteredStatus} />
          </>
        }
        onClearFilters={clearAllFilters}
      />
      <div className="allocation-grid">
        <Board
          data={{ lanes: columnsWithBookings }}
          components={{
            Card: GaragesAllocationCard,
          }}
        />
      </div>
    </div>
  );
};

export default GaragesAllocation;
